module.exports = __webpack_public_path__ + "static/media/nimes_porteauguste.e4e58e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_porteauguste.png
// module id = 733
// module chunks = 0